export const APP_CONFIG = {
    environment: window.__app_config.WEBUI_ENV_NAME,
};
